var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import http, { Q } from "@http";
import { observable, action, runInAction, computed } from "mobx";
import { getUrlParams } from "@common/utils/url";
import { SuperintendentBookingStatus, SuperintendentBookingErrorCode } from "@common/enums/superintendentBooking";
var BOOK_FAILED_MESSAGE = "We couldn't book this time. Please try again.";
var RESCHEDULE_FAILED_MESSAGE = "Your current appointment is still booked.";
var BOOK_UNCONFIRMED_MESSAGE = "We couldn't confirm your booking. Please check your appointment details and try again if needed.";
var SLOT_UNAVAILABLE_MESSAGE = "That time was just taken. Please choose another time.";
var getErrorResponse = function (error) {
    var _a, _b;
    return { status: (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status, data: ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) || {} };
};
var SuperintendentBookingStore = /** @class */ (function () {
    function SuperintendentBookingStore() {
        this.isPageLoading = false;
        this.isDetailLoadFailed = false;
        this.detail = null;
        this.timeOptions = null;
        this.isTimesLoading = false;
        this.isTimesLoadFailed = false;
        this.isMoreTimesOpen = false;
        this.step = "pick";
        this.selectedSlot = null;
        // Continue stays enabled; pressing it with nothing picked shows a prompt instead.
        this.isSelectionMissing = false;
        this.isBooking = false;
        this.isJustBooked = false;
        this.isRescheduling = false;
        // The booking a successful reschedule replaced, shown on the "time is changed" screen.
        this.replacedBooking = null;
        this.errorMessage = "";
        this.timesRequestId = 0;
    }
    Object.defineProperty(SuperintendentBookingStore.prototype, "status", {
        get: function () {
            var _a;
            return (_a = this.detail) === null || _a === void 0 ? void 0 : _a.status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperintendentBookingStore.prototype, "isBookable", {
        get: function () {
            return this.status === SuperintendentBookingStatus.Bookable;
        },
        enumerable: false,
        configurable: true
    });
    SuperintendentBookingStore.prototype.getToken = function () {
        var _a, _b;
        return (_b = (_a = getUrlParams()) === null || _a === void 0 ? void 0 : _a.token) === null || _b === void 0 ? void 0 : _b.split("?")[0];
    };
    SuperintendentBookingStore.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.reset();
                        if (!this.getToken()) {
                            this.detail = { status: SuperintendentBookingStatus.InvalidToken };
                            return [2 /*return*/];
                        }
                        this.isPageLoading = true;
                        return [4 /*yield*/, this.loadDetail()];
                    case 1:
                        _a.sent();
                        runInAction(function () {
                            _this.isPageLoading = false;
                        });
                        if (!(this.isBookable && !this.detail.booking)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.loadTimeOptions()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SuperintendentBookingStore.prototype.loadDetail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data_1, error_1, status_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api().getDetail(this.getToken())];
                    case 1:
                        data_1 = _a.sent();
                        runInAction(function () {
                            _this.detail = data_1;
                            _this.isDetailLoadFailed = false;
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        status_1 = getErrorResponse(error_1).status;
                        if (this.detail && status_1 !== 404) {
                            return [2 /*return*/];
                        }
                        runInAction(function () {
                            if (status_1 === 404) {
                                _this.detail = { status: SuperintendentBookingStatus.InvalidToken };
                            }
                            else {
                                _this.isDetailLoadFailed = true;
                            }
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SuperintendentBookingStore.prototype.loadTimeOptions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requestId, data_2, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.timesRequestId += 1;
                        requestId = this.timesRequestId;
                        this.isTimesLoading = true;
                        this.isTimesLoadFailed = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 6, 7]);
                        return [4 /*yield*/, this.api().getTimeOptions(this.getToken())];
                    case 2:
                        data_2 = _a.sent();
                        if (requestId !== this.timesRequestId) {
                            return [2 /*return*/];
                        }
                        runInAction(function () {
                            _this.timeOptions = {
                                recommended: (data_2 === null || data_2 === void 0 ? void 0 : data_2.recommended) || [],
                                moreDays: (data_2 === null || data_2 === void 0 ? void 0 : data_2.moreDays) || [],
                                moreCount: (data_2 === null || data_2 === void 0 ? void 0 : data_2.moreCount) || 0
                            };
                            if (_this.selectedSlot && !_this.allSlots.some(function (slot) { return slot.startUtc === _this.selectedSlot.startUtc && !slot.isCurrent; })) {
                                _this.selectedSlot = null;
                                _this.step = "pick";
                            }
                        });
                        return [3 /*break*/, 7];
                    case 3:
                        error_2 = _a.sent();
                        if (!(requestId === this.timesRequestId)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.handleTimesError(error_2)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        runInAction(function () {
                            if (requestId === _this.timesRequestId) {
                                _this.isTimesLoading = false;
                            }
                        });
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SuperintendentBookingStore.prototype, "allSlots", {
        get: function () {
            if (!this.timeOptions) {
                return [];
            }
            var slots = __spreadArrays(this.timeOptions.recommended);
            this.timeOptions.moreDays.forEach(function (day) { return slots.push.apply(slots, day.slots); });
            return slots;
        },
        enumerable: false,
        configurable: true
    });
    SuperintendentBookingStore.prototype.retry = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.isDetailLoadFailed || !this.detail)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, this.loadTimeOptions()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SuperintendentBookingStore.prototype.toggleMoreTimes = function () {
        this.isMoreTimesOpen = !this.isMoreTimesOpen;
    };
    SuperintendentBookingStore.prototype.selectSlot = function (slot) {
        this.selectedSlot = slot;
        this.isSelectionMissing = false;
        this.errorMessage = "";
    };
    SuperintendentBookingStore.prototype.goToConfirm = function () {
        if (!this.selectedSlot) {
            this.isSelectionMissing = true;
            return;
        }
        this.step = "confirm";
        this.errorMessage = "";
    };
    SuperintendentBookingStore.prototype.backToPick = function () {
        this.step = "pick";
        this.errorMessage = "";
    };
    SuperintendentBookingStore.prototype.book = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var previousBooking, booking_1, error_3, _b, status, data;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.selectedSlot || this.isBooking) {
                            return [2 /*return*/];
                        }
                        this.isBooking = true;
                        this.errorMessage = "";
                        previousBooking = this.isRescheduling ? (_a = this.detail) === null || _a === void 0 ? void 0 : _a.booking : null;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 11, 12]);
                        return [4 /*yield*/, this.api().book(this.getToken(), this.selectedSlot.startUtc)];
                    case 2:
                        booking_1 = _c.sent();
                        runInAction(function () {
                            _this.detail = __assign(__assign({}, _this.detail), { booking: booking_1 });
                            _this.replacedBooking = previousBooking || null;
                            _this.isJustBooked = true;
                            _this.isRescheduling = false;
                            _this.selectedSlot = null;
                            _this.step = "pick";
                        });
                        return [3 /*break*/, 12];
                    case 3:
                        error_3 = _c.sent();
                        _b = getErrorResponse(error_3), status = _b.status, data = _b.data;
                        if (!(status === 409 || data.code === SuperintendentBookingErrorCode.SlotUnavailable)) return [3 /*break*/, 5];
                        runInAction(function () {
                            _this.selectedSlot = null;
                            _this.step = "pick";
                            _this.errorMessage = SLOT_UNAVAILABLE_MESSAGE;
                        });
                        return [4 /*yield*/, this.loadTimeOptions()];
                    case 4:
                        _c.sent();
                        return [3 /*break*/, 10];
                    case 5:
                        if (!(status === 410 || status === 404)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.handleNotBookable()];
                    case 6:
                        _c.sent();
                        return [3 /*break*/, 10];
                    case 7:
                        if (!(status === 502)) return [3 /*break*/, 9];
                        runInAction(function () {
                            _this.errorMessage = BOOK_UNCONFIRMED_MESSAGE;
                        });
                        return [4 /*yield*/, this.loadDetail()];
                    case 8:
                        _c.sent();
                        runInAction(function () {
                            var _a, _b, _c;
                            if (_this.isRescheduling) {
                                // The gateway timed out, but the change may still have gone through: trust the reloaded booking.
                                if (((_a = _this.detail) === null || _a === void 0 ? void 0 : _a.booking) && _this.detail.booking.startUtc === ((_b = _this.selectedSlot) === null || _b === void 0 ? void 0 : _b.startUtc)) {
                                    _this.replacedBooking = previousBooking || null;
                                    _this.isJustBooked = true;
                                    _this.isRescheduling = false;
                                    _this.selectedSlot = null;
                                    _this.step = "pick";
                                    _this.errorMessage = "";
                                }
                                else {
                                    _this.errorMessage = RESCHEDULE_FAILED_MESSAGE;
                                }
                            }
                            else if ((_c = _this.detail) === null || _c === void 0 ? void 0 : _c.booking) {
                                _this.selectedSlot = null;
                                _this.step = "pick";
                            }
                        });
                        return [3 /*break*/, 10];
                    case 9:
                        runInAction(function () {
                            _this.errorMessage = _this.isRescheduling ? RESCHEDULE_FAILED_MESSAGE : BOOK_FAILED_MESSAGE;
                        });
                        _c.label = 10;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        runInAction(function () {
                            _this.isBooking = false;
                        });
                        return [7 /*endfinally*/];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    SuperintendentBookingStore.prototype.startReschedule = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isRescheduling = true;
                        this.isJustBooked = false;
                        this.replacedBooking = null;
                        this.errorMessage = "";
                        this.selectedSlot = null;
                        this.isSelectionMissing = false;
                        this.isMoreTimesOpen = false;
                        this.step = "pick";
                        return [4 /*yield*/, this.loadTimeOptions()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SuperintendentBookingStore.prototype.cancelReschedule = function () {
        this.timesRequestId += 1;
        this.isRescheduling = false;
        this.isTimesLoading = false;
        this.isTimesLoadFailed = false;
        this.selectedSlot = null;
        this.isSelectionMissing = false;
        this.step = "pick";
        this.errorMessage = "";
    };
    SuperintendentBookingStore.prototype.handleTimesError = function (error) {
        return __awaiter(this, void 0, void 0, function () {
            var status;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        status = getErrorResponse(error).status;
                        if (!(status === 410 || status === 404)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.handleNotBookable()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        runInAction(function () {
                            _this.isTimesLoadFailed = true;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    SuperintendentBookingStore.prototype.handleNotBookable = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isRescheduling = false;
                        this.step = "pick";
                        return [4 /*yield*/, this.loadDetail()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SuperintendentBookingStore.prototype.reset = function () {
        this.timesRequestId += 1;
        this.isPageLoading = false;
        this.isDetailLoadFailed = false;
        this.detail = null;
        this.timeOptions = null;
        this.isTimesLoading = false;
        this.isTimesLoadFailed = false;
        this.isMoreTimesOpen = false;
        this.step = "pick";
        this.selectedSlot = null;
        this.isSelectionMissing = false;
        this.isBooking = false;
        this.isJustBooked = false;
        this.isRescheduling = false;
        this.replacedBooking = null;
        this.errorMessage = "";
    };
    SuperintendentBookingStore.prototype.api = function () {
        return {
            getDetail: function (token) {
                return Q(http.post("/SuperintendentBooking/Detail", { token: token }));
            },
            getTimeOptions: function (token) {
                return Q(http.post("/SuperintendentBooking/TimeOptions", { token: token }));
            },
            book: function (token, startUtc) {
                return Q(http.post("/SuperintendentBooking/Book", { token: token, startUtc: startUtc }));
            },
        };
    };
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "isPageLoading", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "isDetailLoadFailed", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "detail", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "timeOptions", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "isTimesLoading", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "isTimesLoadFailed", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "isMoreTimesOpen", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "step", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "selectedSlot", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "isSelectionMissing", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "isBooking", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "isJustBooked", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "isRescheduling", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "replacedBooking", void 0);
    __decorate([
        observable
    ], SuperintendentBookingStore.prototype, "errorMessage", void 0);
    __decorate([
        computed
    ], SuperintendentBookingStore.prototype, "status", null);
    __decorate([
        computed
    ], SuperintendentBookingStore.prototype, "isBookable", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "init", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "loadDetail", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "loadTimeOptions", null);
    __decorate([
        computed
    ], SuperintendentBookingStore.prototype, "allSlots", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "retry", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "toggleMoreTimes", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "selectSlot", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "goToConfirm", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "backToPick", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "book", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "startReschedule", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "cancelReschedule", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "handleTimesError", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "handleNotBookable", null);
    __decorate([
        action.bound
    ], SuperintendentBookingStore.prototype, "reset", null);
    return SuperintendentBookingStore;
}());
export default SuperintendentBookingStore;
